import JsFunction from "./JsFunction";

export default class ServiceFunction extends JsFunction {
  
    nextFunction;

    bodyPar;

    headers;

    queryPar;

    url;

    serviceName;

    selectedInputs = [];

    ids = [];

    typeRequest;

    compId;

    constructor(method, annotations,htmlDom) {
        
        super(method, annotations);
        this.bodyPar = method.body_par;
        this.headers = method.headers;
        this.queryPar = method.query_par;
        this.url = method.url;
        this.serviceName = method.service_name;
        this.compId = method.compId;
        this.typeRequest = method.typeRequest;
        this.findInnerServiceComps(annotations, htmlDom)

    }

    printFunction() {
        
        this.functionality = this.basicServiceFuncionality();
        return this.functionality;

    }

    basicServiceFuncionality(){

        return `
            ${this.returnLoadHistoryParams()}
            fetch(\`${this.url}${this.fillQueryParams()}\`,{
                method: "${this.typeRequest}", \n
                ${this.fillHeaders()}
                ${this.fillBodyParams()}
            })
            .then(response => 
                response.json().then(data => {
                    ${this.createResponseFunctionality()}
                })
            )
        `

    }

    returnLoadHistoryParams(){

        let initHeaderParams = '';
        let initQueryParams = '';
        let initBodyParams = '';
        this.headers.forEach( (header,index) => {
            initHeaderParams += `const header${index} = (service && service.headers && service.headers['${header[0]}'] !== undefined) ? service.headers['${header[0]}'] : '${header[1]}';`
        })
        this.queryPar.forEach( (queryParam, index) => {
            initQueryParams += `const queryPar${index} = (service && service.queryParams && service.queryParams['${queryParam[0]}'] !== undefined) ? service.queryParams['${queryParam[0]}'].replaceAll(',','%2C') : '${queryParam[1]}';`
        })
        this.bodyPar.forEach( ( bodyParam, index) => {
            initBodyParams += `const bodyPar${index} = (service && service.bodyParams && service.bodyParams['${bodyParam[0]}'] !== undefined) ? service.bodyParams['${bodyParam[0]}'] : '${bodyParam[1]}';`
        })

        return `
            const serviceData = JSON.parse(sessionStorage.getItem('serviceData'));
            const service = serviceData ? serviceData['${this.url}'] : null;
                ${initHeaderParams}
                ${initQueryParams}
                ${initBodyParams}
        `;
    }

    fillQueryParams(){

        switch(this.typeRequest){
            case('GET'):
                return this.createQueryString();
            case('PUT'):
                return ``;
            case('POST'):
                return ``;
            case('DELETE'):
                return this.createQueryString();
            default:
                return ``;
        }
    }

    createQueryString(){

        let queryString = '?';
        this.queryPar.forEach( (par,index) => {
            if(index > 0) queryString += '&'
            
            queryString += `${par[0]}=`+`$`+`{`+`queryPar${index}}`
        })
        return queryString;
    }

    fillHeaders(){
        let headers = 'headers: {';
        this.headers.forEach( (header,index) => {
            if(index>0) headers += ', \n'
            headers += `'${header[0]}' : header${index}`
        })
        headers += '}';
        headers += ( this.typeRequest === 'POST' || this.typeRequest === 'PUT' ) ? ', \n' : '\n'; 
        return headers;
    }

    fillBodyParams(){
        switch(this.typeRequest){
            case('GET'):
                return ``;
            case('PUT'):
                return `${this.createBodyParams()}`;
            case('POST'):
                return `${this.createBodyParams()}`;
            case('DELETE'):
                return ``;
        }
    }

    createBodyParams(){
        let bodyParams = 'body: JSON.stringify({';
        this.bodyPar.forEach( (bodyPar,index) => {
            if(index>0) bodyParams += ', \n'
            bodyParams += `'${bodyPar[0]}' : bodyPar${index}`
        })
        headers += '})\n';
        return bodyParams;
    }

    createResponseFunctionality(){

        let responseFuncionality = '';

        this.ids.forEach( (id, index) => {
            responseFuncionality += `
            try{
                document.getElementById('${id}').textContent = data.${this.selectedInputs[index]};
            }
            catch(e){
                console.log(e);
            }\n`
        })
        return responseFuncionality;

    }

    findInnerServiceComps(annotations, htmlDom){
        
        let comp = htmlDom.getElementById(this.compId);

        if(comp){

            const insideAnns = comp.querySelectorAll('[annotationname]');
            const insideAnnSelectedAttrs = [...insideAnns].filter(node => this.belongToService(node, annotations)=== true).map( node => this.returnSelectedAttr(node.getAttribute('annotationname')));
            const insideAnnIds = [...insideAnns].filter(node => this.belongToService(node, annotations)=== true).map( node => node.getAttribute('id'));
            this.ids = insideAnnIds;
            this.selectedInputs = insideAnnSelectedAttrs;
        }

    }

    belongToService(node, annotations){
            
        let foundSameAnnotationService = false;

        annotations[0].combinations.forEach( comb => {

            if(comb.annotationName === node.getAttribute('annotationname') && comb.attributeType === 'service' && comb.attributeTypeService === this.serviceName){
                foundSameAnnotationService = true;
            }
        })
        return foundSameAnnotationService;
    }

    returnSelectedAttr(annotationName){
        return this.annotations[0].combinations.filter( ann => ann.annotationName === annotationName).map( ann => ann.serviceAttr)[0];
    }

    printImportStatement(){
        return '';
    }

}